import type { DocumentRevision } from '@/entities/Document';
import { useDocumentSelection, useDocumentTableSelection } from '@/features/Document';
import { DOCUMENT_LIST_ORDER_OPTIONS } from '@/shared/config';

interface UseDocumentListTableOperationsOptions {
  revisions: () => DocumentRevision[];
  onSort: (sortCamp: string, orderFlow: string) => void;
  onFilter: (filters: Record<string, any>) => void;
  onFilterClicked: () => void;
}

export function useDocumentListTableOperations(options: UseDocumentListTableOperationsOptions) {
  const { revisions, onSort, onFilter, onFilterClicked } = options;

  const {
    selectedCount,
    hasSelectedDocuments,
    isDocumentSelected,
    selectedDocuments,
    deselectAllDocuments,
  } = useDocumentSelection();

  const { handleToggleSelection, handleToggleAll, allSelected } = useDocumentTableSelection({
    revisions,
  });

  const handleSortOptions = (sortCamp: string, orderFlow: string) => {
    onSort(sortCamp, orderFlow);
  };

  const handleFilter = (filters: any) => {
    onFilter(filters);
  };

  const handleFilterClicked = () => {
    onFilterClicked();
  };

  const orderOptions = DOCUMENT_LIST_ORDER_OPTIONS;

  return {
    // Selection
    selectedCount,
    hasSelectedDocuments,
    isDocumentSelected,
    selectedDocuments,
    deselectAllDocuments,
    handleToggleSelection,
    handleToggleAll,
    allSelected,

    // Sort/Filter
    handleSortOptions,
    handleFilter,
    handleFilterClicked,
    orderOptions,
  };
}
